"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asEntriesFactory = void 0;
/**
 * Create an EntriesCollector for the given grouping.
 *
 * @param groups The grouping.
 * @returns The created collector.
 */
function asEntriesFactory(groups) {
    return ((options) => {
        var _a, _b;
        const keyName = (_a = options === null || options === void 0 ? void 0 : options.keyName) !== null && _a !== void 0 ? _a : 'key';
        const itemsName = (_b = options === null || options === void 0 ? void 0 : options.itemsName) !== null && _b !== void 0 ? _b : 'items';
        return groups.map((g) => ({
            [keyName]: g.key,
            [itemsName]: g.items
        }));
    });
}
exports.asEntriesFactory = asEntriesFactory;
